import { InputBaseComponentProps, InputBaseProps } from '@mui/material';
import React from 'react';
import { IMaskInput, IMaskInputProps } from 'react-imask';

interface MaskedNumericInputProps {
  inputProps: InputBaseComponentProps;
  maskProps: IMaskInputProps<HTMLInputElement>;
  ref: InputBaseProps['ref'];
}

/**
 * @returns pseudo React.FormEvent<HTMLInputElement> with a target.value of type string, and no other properties
 */
const getCustomEvent = (value: unknown) => {
  return { target: { value: typeof value === 'string' ? value : '' } } as unknown as React.FormEvent<HTMLInputElement>;
};

export const MaskedInput = (props: MaskedNumericInputProps) => {
  const { inputProps, maskProps, ref } = props;
  const { onChange, ...restInputProps } = inputProps;

  return (
    <IMaskInput
      {...maskProps}
      {...restInputProps}
      inputRef={ref as React.RefCallback<HTMLInputElement>}
      onAccept={(value: unknown, _mask) => {
        const event = getCustomEvent(value);
        if (onChange !== undefined) onChange(event);
      }}
    />
  );
};
